import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDrawer3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"drawer-3"} maskId="square-filled-radius-0-stroke-1-IconDrawer3"><path fillRule="evenodd" clipRule="evenodd" d="M11.5 4H2V19H4V21H5V19H11.5V4ZM10 9V13H9V9H10Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M20 19H22V4H12.5V19H19V21H20V19ZM15 9H14V13H15V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDrawer3;
